module.exports = __webpack_public_path__ + "static/icons/browserconfig.xml";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/browserconfig.xml
// module id = 4FwX
// module chunks = 0